import { AxiosPromise, AxiosResponse } from "axios";
import { format } from "date-fns";
import { httpClient } from "src/shared/services/httpClient";
import {
  TAdminCashierReportParamsRespose as TAdminCashierReportParamsResponse,
  TAdminFinancialReportParamsRespose,
  TAdminKedeSubscriptionsParamsRespose,
  TAdminUnpaidSubscriptionsParamsRespose,
  TAlterUserFilters,
  TCertPaymentFilters,
  TCertPaymentParamsResponse,
  TCopySubscr,
  TPaymentIntegrityInsertEmailsParams,
  TPaymentIntegrityParams,
  TPaymentIntegrityReport,
  TDeleteAppTypeFilters,
  TDiasFileDetailsResponse,
  TDiasFilesFilters,
  TDiasFilesResponse,
  TDiasFixFilters,
  TDiasOnlineFilters,
  TDiasOnlineParamsResponse,
  TFixWrongRi3DiasPaymentFilters,
  TGetAppTypesFilters,
  TGetAppTypesParamsResponse,
  TGetBusinessUserResponse,
  TGetCertTypesFilters,
  TGetCertTypesParamsResponse,
  TGetChamberUserResponse,
  TGetImpersonationBusinessPageResponse,
  TGetImpersonationNonGemiPageResponse,
  TGetImpersonationPageResponse,
  TGetPaidSubscriptionParamsResponse,
  TGetUserFilters,
  TGetUserResponse,
  TGetViewPaymentsForRefundResponse,
  TMutateCertTypeFilters,
  TPaymentDetailsParamsResponse,
  TPaymentFilters,
  TPaymentParamsResponse,
  TPaymentSumsFilters,
  TPaymentSumsParamsResponse,
  TShowSubscrFilters,
  TSubmitSqlFilters,
  TSubmitSqlResponse,
  TUpdateAppTypeFilters,
  TAadeManualSyncParams,
  TManualAadeSyncResult,
  TUpdateCardRefundFilters,
  TUpdateCreditCardApplicationRefundFilters,
  TUpdateDiasRefundFilters,
  TUpdateSubscr,
  TViewPaymentsForRefundParamsResponse,
} from "../types";
import { TsearchFilters } from "src/admin/data-access/SubscriptionRelief/useSearchSubscriptionWithoutRelief";
import { ParametricType } from "src/shared/types";
import { ViolationType } from "src/violationCase/types";

export const getApplicationsParams = () => httpClient.get("admin/applications");

export const getCertificatesParams = () => httpClient.get("admin/certificates");

export const getNameTitlePurchasesParams = () =>
  httpClient.get("admin/nameTitlePurchase");

export const getNameTitleClaimPurchasesParams = () =>
  httpClient.get("admin/nameTitleClaimPurchase");

export const getApplications = (searchFilters: FormData) =>
  httpClient.post("admin/getApplicationsJSON", searchFilters);

export const getCertificates = (searchFilters: FormData) =>
  httpClient.post("admin/getCertificatesJSON", searchFilters);

export const getNameTitlePurchases = (params: {
  fromDate: string | undefined;
  toDate: string | undefined;
  namePurchaseAppId: string | undefined;
  code: string | undefined;
  purchaseCode: string | undefined;
  columnsCount: string;
  length: string;
  start: string;
}) =>
  httpClient.get("admin/getNameTitlePurchasesJSON", {
    params: {
      ...params,
    },
  });

export const getNameTitleClaimPurchases = (searchFilters: FormData) =>
  httpClient.post("admin/getNameTitleClaimPurchasesJSON", searchFilters);

export const getAdminCashierStats = () => {
  return httpClient.get("/admin/cashierStatsJSON");
};

export const getAdminFinancialReportParams =
  (): AxiosPromise<TAdminFinancialReportParamsRespose> => {
    return httpClient.get("/admin/financialReport");
  };

export const getAdminCashierReportParams =
  (): AxiosPromise<TAdminCashierReportParamsResponse> => {
    return httpClient.get("/admin/cashierReport");
  };

export const getAdminUnpaidSubscriptionsParams =
  (): AxiosPromise<TAdminUnpaidSubscriptionsParamsRespose> =>
    httpClient.get("admin/unpaidSubscriptions");

export const getAdminKedeSubscriptionsParams =
  (): AxiosPromise<TAdminKedeSubscriptionsParamsRespose> =>
    httpClient.get("admin/kedeSubscriptions");

export const getPaidSubscriptionParams =
  (): AxiosPromise<TGetPaidSubscriptionParamsResponse> =>
    httpClient.get("admin/paidSubscriptions");

export const getPaymentParams = (
  filters: TPaymentFilters,
): AxiosPromise<TPaymentParamsResponse> => {
  const formData = new FormData();
  filters.fromDate &&
    formData.append("fromDate", format(filters.fromDate, "dd/MM/yyyy"));
  filters.toDate &&
    formData.append("toDate", format(filters.toDate, "dd/MM/yyyy"));
  filters.gemiNum && formData.append("gemiNum", filters.gemiNum);
  return httpClient.post("/admin/payments", formData);
};

export const getCertPaymentParams = (
  filters: TCertPaymentFilters,
): AxiosPromise<TCertPaymentParamsResponse> => {
  const formData = new FormData();
  filters.fromDate &&
    formData.append("fromDate", format(filters.fromDate, "dd/MM/yyyy"));
  filters.toDate &&
    formData.append("toDate", format(filters.toDate, "dd/MM/yyyy"));
  return httpClient.post("/admin/certPayments", formData);
};

export const getPaymentSumsParams = (
  filters: TPaymentSumsFilters,
): AxiosPromise<TPaymentSumsParamsResponse> => {
  const formData = new FormData();

  const endpoint = filters.isCashier
    ? "/cashier/paymentSums"
    : "/admin/paymentSums";

  filters.fromDate &&
    formData.append("fromDate", format(filters.fromDate, "dd/MM/yyyy"));
  filters.toDate &&
    formData.append("toDate", format(filters.toDate, "dd/MM/yyyy"));
  return httpClient.post(endpoint, formData);
};

export const updateCardRefund = (data: TUpdateCardRefundFilters) => {
  const formData = new FormData();
  data.subscrM06 && formData.append("subscrM06", data.subscrM06);
  data.subscrArgemi && formData.append("subscrArgemi", data.subscrArgemi);
  data.refundCardDate &&
    formData.append(
      "refundCardDate",
      format(data.refundCardDate, "dd/MM/yyyy"),
    );
  return httpClient.post("/admin/updateCardRefund", formData);
};

export const updateDiasRefund = (data: TUpdateDiasRefundFilters) => {
  const formData = new FormData();
  data.ri3 && formData.append("ri3", data.ri3);
  data.refundDate &&
    formData.append("refundDate", format(data.refundDate, "dd/MM/yyyy"));
  return httpClient.post("/admin/updateDiasRefund", formData);
};

export const updateCreditCardApplicationRefund = (
  data: TUpdateCreditCardApplicationRefundFilters,
) => {
  const formData = new FormData();
  data.appID && formData.append("appID", data.appID);
  data.refundAppDate &&
    formData.append("refundAppDate", format(data.refundAppDate, "dd/MM/yyyy"));
  return httpClient.post("/admin/updateCreditCardApplicationRefund", formData);
};

export const getViewPaymentsForRefundParams =
  (): AxiosPromise<TViewPaymentsForRefundParamsResponse> => {
    return httpClient.get("/admin/viewPaymentsForRefund");
  };

export const getViewPaymentsForRefund = ({
  fromDate,
  toDate,
  m02_id,
  paymentType,
  m05_id,
  length,
  start,
}: {
  fromDate: string | undefined;
  toDate: string | undefined;
  m02_id: string | undefined;
  paymentType: string | undefined;
  m05_id: string | undefined;
  length: string | undefined;
  start: string | undefined;
}): AxiosPromise<TGetViewPaymentsForRefundResponse> => {
  let url =
    "/admin/viewPaymentsForRefundJSON?length=" + length + "&start=" + start;
  if (fromDate) {
    url = url + "&fromDate=" + fromDate;
  }
  if (toDate) {
    url = url + "&toDate=" + toDate;
  }
  if (m02_id) {
    url = url + "&m02_id=" + m02_id;
  }
  if (paymentType) {
    url = url + "&paymentType=" + paymentType;
  }
  if (m05_id) {
    url = url + "&m05_id=" + m05_id;
  }
  return httpClient.get(url);
};

export const getDiasFiles = (
  filters: TDiasFilesFilters,
): AxiosPromise<TDiasFilesResponse> => {
  const endpoint = filters.isCashier
    ? "/cashier/diasFiles"
    : "/admin/diasFiles";
  const formData = new FormData();
  filters.fromDate &&
    formData.append("fromDate", format(filters.fromDate, "dd/MM/yyyy"));
  filters.toDate &&
    formData.append("toDate", format(filters.toDate, "dd/MM/yyyy"));
  return httpClient.post(endpoint, formData);
};

export const getManageApplicationParams = (appId: string | undefined) =>
  httpClient.get(`admin/manageApplicationReact?appId=${appId}`);
export const getManageCertificateApplicationParams = (certId: string) =>
  httpClient.get(`admin/manageCertificateApplication?certId=${certId}`);

export const getQuickParams = (mode: string) => httpClient.get(`admin/${mode}`);
export const getDiasFileDetails = (
  fileId: string,
  isCashier: boolean,
): AxiosPromise<TDiasFileDetailsResponse> =>
  httpClient.get(
    `${isCashier ? "cashier" : "admin"}/diasFileDetails?diasFile=${fileId}`,
  );

export const getDiasOnlinePayments = (
  filters: TDiasOnlineFilters,
): AxiosPromise<TDiasOnlineParamsResponse> => {
  const formData = new FormData();
  filters.fromDate &&
    formData.append("fromDate", format(filters.fromDate, "dd/MM/yyyy"));
  filters.toDate &&
    formData.append("toDate", format(filters.toDate, "dd/MM/yyyy"));
  return httpClient.post("/admin/diasOnline", formData);
};

export const submitDiasFix = (data: TDiasFixFilters) => {
  const formData = new FormData();
  formData.append("problematicRi3", data.problematicRi3);
  formData.append("nPaymentId", data.nPaymentId);
  formData.append("mPaymentId", data.mPaymentId);
  return httpClient.post("/admin/diasFix", formData);
};

export const submitFixWrongRi3DiasPayment = (
  data: TFixWrongRi3DiasPaymentFilters,
) => {
  const formData = new FormData();
  formData.append("wrongRi3", data.wrongRi3);
  formData.append("correctRi3", data.correctRi3);
  formData.append("argemi", data.argemi);
  return httpClient.post("/admin/fixWrongRi3DiasPayment", formData);
};

export const getPaymentDetails = (filters: {
  paymentDate: string;
  chamberDescr: string;
  isCashier?: boolean;
}): AxiosPromise<TPaymentDetailsParamsResponse> => {
  const endpoint = filters.isCashier
    ? "/cashier/paymentDetails"
    : "/admin/paymentDetails";

  const formData = new FormData();
  formData.append("paymentDate", filters.paymentDate);
  formData.append("chamberDescr", filters.chamberDescr);
  return httpClient.post(endpoint, formData);
};

export const getInspectPaymentParams = ({
  m05Id,
  n05Id,
  ri3Id,
}: {
  m05Id: string;
  n05Id: string;
  ri3Id: string;
}) => {
  return httpClient.get(`admin/inspectPayment`, {
    params: { m05Id: m05Id, n05Id: n05Id, ri3Id: ri3Id },
  });
};

export const getAppTypes = (filters: TGetAppTypesFilters) => {
  const formData = new FormData();
  filters.m00Id ? formData.append("m00Id", filters.m00Id) : null;
  filters.legalType ? formData.append("legalType", filters.legalType) : null;
  filters.kakType ? formData.append("kakType", filters.kakType) : null;
  return httpClient.post("/admin/getAppTypesJSON", formData);
};

export const updateAppType = (data: TUpdateAppTypeFilters) => {
  const formData = new FormData();
  data.commentsEn && formData.append("commentsEn", data.commentsEn);
  data.m00_comments && formData.append("m00_comments", data.m00_comments);
  data.m00_double_kak &&
    formData.append("m00_double_kak", data.m00_double_kak.toString());
  data.m00_append && formData.append("m00_append", data.m00_append.toString());
  data.m00_sign && formData.append("m00_sign", data.m00_sign);
  data.m00_auto && formData.append("m00_auto", data.m00_auto.toString());
  data.m00_is_et && formData.append("m00_is_et", data.m00_is_et.toString());
  data.m00_is_region &&
    formData.append("m00_is_region", data.m00_is_region.toString());
  data.m00_is_notary &&
    formData.append("m00_is_notary", data.m00_is_notary.toString());
  data.m00_ggeallowed &&
    formData.append("m00_ggeallowed", data.m00_ggeallowed.toString());
  data.m00_is_online &&
    formData.append("m00_is_online", data.m00_is_online.toString());
  data.m00_cost !== undefined &&
    formData.append("m00_cost", data.m00_cost.toString());
  data.m00_sort && formData.append("m00_sort", data.m00_sort.toString());
  data.m00_d08_id && formData.append("m00_d08_id", data.m00_d08_id.toString());
  data.m00_d55_id && formData.append("m00_d55_id", data.m00_d55_id.toString());
  data.descrEn && formData.append("descrEn", data.descrEn);
  data.m00_descr && formData.append("m00_descr", data.m00_descr);
  data.m00_id !== undefined &&
    formData.append("m00_id", data.m00_id.toString());
  if (data?.table_id?.length > 0) {
    data?.table_id.forEach((id) => formData.append("table_id", id.toString()));
  }
  if (!data.mode) {
    return;
  } else {
    formData.append("mode", data.mode);
  }
  return httpClient.post("/admin/appTypes", formData);
};

export const deleteAppType = (data: TDeleteAppTypeFilters) => {
  const formData = new FormData();
  data.m00_id !== undefined &&
    formData.append("m00_id", data.m00_id.toString());
  formData.append("mode", "delete");
  return httpClient.post("/admin/appTypes", formData);
};

export const getWrongSubscriptions = (formData: FormData) =>
  httpClient.post("/admin/wrongSubscriptions", formData);

export const deleteUnpaidSubscription = ({
  m06_id,
  m05_id,
  gemiNumber,
}: {
  m06_id: string;
  m05_id: string;
  gemiNumber: string;
}) => {
  const formData = new FormData();
  formData.append("m06_id", m06_id);
  formData.append("m05_id", m05_id);
  formData.append("gemiNumber", gemiNumber);
  return httpClient.post("/admin/deleteUnpaidSubscription", formData, {
    responseType: "text",
  });
};

export const getListJobs = () => httpClient.get("/admin/listJobs");

export const jobAction = ({
  group,
  name,
  action,
}: {
  group: string;
  name: string;
  action: string;
}) => {
  const formData = new FormData();
  formData.append("jobGroup", group);
  formData.append("jobName", name);
  return httpClient.post(`/admin/${action}`, formData);
};

export const pauseAllJobs = () => httpClient.post("/admin/pauseAllJobs");
export const resumeAllJobs = () => httpClient.post("/admin/resumeAllJobs");

export const getOrgAdminData = () => httpClient.get("/admin/orgAdminData");

export const updateUser = (data: { isAdmin: boolean; user_id: number }) => {
  const formData = new FormData();

  formData.append("a13_a06_id", data.user_id.toString());
  formData.append("a13_is_chamber_admin", data.isAdmin.toString());

  return httpClient.post("/admin/updateOrgAdminPrivileges", formData);
};

export const getActiveBusinessParams = () =>
  httpClient.get("/admin/activeBusiness");

export const getActiveBusinessCountParams = () =>
  httpClient.get("/admin/activeBusinessCount");

export const fixMissingInvoices = () =>
  httpClient.get("/admin/fixMissingInvoicesReact");
export const getAppTypesParams =
  (): AxiosPromise<TGetAppTypesParamsResponse> => {
    return httpClient.get("/admin/appTypes");
  };

export const getCertTypesParams =
  (): AxiosPromise<TGetCertTypesParamsResponse> =>
    httpClient.get("/admin/certTypesParams");

export const getCertTypes = (filters: TGetCertTypesFilters) => {
  const formData = new FormData();
  filters.n00_id ? formData.append("n00_id", filters.n00_id) : null;
  filters.legalType ? formData.append("legalType", filters.legalType) : null;
  filters.certType ? formData.append("certType", filters.certType) : null;
  return httpClient.post("/admin/getCertTypesJSON", formData);
};

export const mutateCertType = (data: TMutateCertTypeFilters) => {
  const formData = new FormData();
  data.n00_id !== undefined &&
    formData.append("n00_id", data.n00_id.toString());
  data.n00_code && formData.append("n00_code", data.n00_code.toString());
  data.n00_descr && formData.append("n00_descr", data.n00_descr);
  data.descrEn && formData.append("descrEn", data.descrEn);
  data.n00_d08_id && formData.append("n00_d08_id", data.n00_d08_id.toString());
  data.n00_allowscomments &&
    formData.append("n00_allowscomments", data.n00_allowscomments.toString());
  data.n00_isavailable &&
    formData.append("n00_isavailable", data.n00_isavailable.toString());
  data.n00_comments && formData.append("n00_comments", data.n00_comments);
  data.commentsEn && formData.append("commentsEn", data.commentsEn);
  data.mode && formData.append("mode", data.mode);
  return httpClient.post("/admin/certTypes", formData);
};

export const getCompanyRefundSubscriptionParams = () =>
  httpClient.get("/admin/companyRefundSubscription");

export const searchRefundSubscription = (formData: FormData) =>
  httpClient.post("/admin/searchRefundSubscription", formData);

export const updateRefundSubscription = ({
  argemi,
  year,
  m06Id,
  newPaymentAmount,
}: {
  argemi: string;
  year: string;
  m06Id: string;
  newPaymentAmount: string;
}) => {
  const formData = new FormData();
  formData.append("argemi", argemi);
  formData.append("year", year);
  formData.append("m06Id", m06Id);
  formData.append("newPaymentAmount", newPaymentAmount);
  return httpClient.post("/admin/updateRefundSubscription", formData);
};

export const updateUnpaidSubscrFlags = ({ gemiNum }: { gemiNum: string }) => {
  const formData = new FormData();
  formData.append("gemiNum", gemiNum);
  return httpClient.post("/admin/updateUnpaidSubscrFlags", formData);
};

export const submitAadeManualSync = (
  data: TAadeManualSyncParams,
): AxiosPromise<TManualAadeSyncResult> => {
  const formData = new FormData();
  formData.append("companyId", data.companyId);
  return httpClient.post("/aadeManualSync/syncCompany", formData);
};

export const wrongChamberForApplication = (formData: FormData) => {
  return httpClient.post("/admin/wrongChamberForApplication", formData);
};

export const moveApplicationToChamber = ({
  m02_id,
  n02_id,
  d05_id,
}: {
  m02_id?: string;
  n02_id?: string;
  d05_id: string;
}) => {
  const formData = new FormData();
  if (m02_id && m02_id?.length > 0) {
    formData.append("m02_id", m02_id);
  }
  if (n02_id && n02_id?.length > 0) {
    formData.append("n02_id", n02_id);
  }
  formData.append("d05_id", d05_id);
  return httpClient.post("/admin/moveApplicationToChamber", formData);
};

export const getShowSubscrParams = (filters: TShowSubscrFilters) => {
  const formData = new FormData();
  filters.year && formData.append("year", filters.year);
  return httpClient.post("/admin/showSubscr", formData);
};

export const updateSubscr = (data: TUpdateSubscr) => {
  const formData = new FormData();
  data.m09_id && formData.append("m09_id", data.m09_id.toString());
  data.m09_subscription_cost !== undefined &&
    formData.append(
      "m09_subscription_cost",
      data.m09_subscription_cost.toString(),
    );
  data.m09_ypokat_imed !== undefined &&
    formData.append("m09_ypokat_imed", data.m09_ypokat_imed.toString());
  data.m09_ypokat_allod !== undefined &&
    formData.append("m09_ypokat_allod", data.m09_ypokat_allod.toString());
  data.m09_taxis_deadline &&
    formData.append(
      "m09_taxis_deadline",
      format(data.m09_taxis_deadline, "dd/MM/yyyy"),
    );
  return httpClient.post("/admin/updateSubscr", formData);
};

export const copySubscr = (data: TCopySubscr) => {
  const formData = new FormData();
  formData.append("fromYear", data.fromYear.toString());
  formData.append("toYear", data.toYear.toString());
  return httpClient.post("/admin/copySubscr", formData);
};

export const moveAllAppToNewChamber = ({
  argemi,
  d05_id,
}: {
  argemi: string;
  d05_id: string;
}) => {
  const formData = new FormData();
  formData.append("argemi", argemi);
  formData.append("d05_id", d05_id);
  return httpClient.post("/admin/moveAllAppToNewChamber", formData);
};

export const moveAllAppToNewChamberParams = (): AxiosPromise<
  ParametricType[]
> => httpClient.get("/admin/moveAllAppToNewChamberParams");

export const getUser = (
  filters: TGetUserFilters,
): AxiosPromise<TGetUserResponse> => {
  const formData = new FormData();
  filters.m01_e03_id &&
    formData.append("m01_e03_id", filters.m01_e03_id.toString());
  return httpClient.post("/admin/searchUser", formData);
};

export const alterUser = (filters: TAlterUserFilters): AxiosPromise<string> => {
  const formData = new FormData();
  if (filters.mode === "alterUsername") {
    formData.append("m01_username", filters.m01_username);
  } else if (filters.mode === "alterEmail") {
    formData.append("m01_email", filters.m01_email);
  }
  formData.append("mode", filters.mode);
  formData.append("m01_e03_id", filters.m01_e03_id);
  return httpClient.post("/admin/alterM01User", formData);
};

export const getImpersonationPageParams =
  (): AxiosPromise<TGetImpersonationPageResponse> =>
    httpClient.get("/admin/impersonationPage");

export const getChamberUser = (filters: {
  id: string;
}): AxiosPromise<TGetChamberUserResponse> => {
  const formData = new FormData();
  formData.append("id", filters.id);
  return httpClient.post("/admin/getChamberUser", formData);
};

export const impersonateUser = (filters: {
  id: string;
}): AxiosPromise<TGetChamberUserResponse> => {
  const formData = new FormData();
  formData.append("userId", filters.id);
  return httpClient.post("/admin/impersonation", formData);
};

export const impersonateBusiness = (filters: {
  id: string;
  m01Id: string;
}): AxiosPromise<TGetBusinessUserResponse> => {
  const formData = new FormData();
  formData.append("bid", filters.id);
  formData.append("m01Id", filters.m01Id);
  return httpClient.post("/admin/impersonationBusiness", formData);
};

export const imersonateNonGemi = (filters: {
  userId: number;
}): AxiosPromise => {
  const formData = new FormData();
  formData.append("userId", filters.userId.toString());
  return httpClient.post("/admin/impersonationNonGemi", formData);
};

export const getImpersonationPageBusinessParams = (
  argemi: string,
): AxiosPromise<TGetImpersonationBusinessPageResponse> =>
  httpClient.get("/admin/impersonationPageBusiness?bid=" + argemi);

export const getImpersonationPageNonGemiParams = (
  searchFilters: FormData,
): AxiosPromise<TGetImpersonationNonGemiPageResponse> =>
  httpClient.post("/admin/getNonGemiJSON", searchFilters);

export const disableImpersonation = () => {
  return httpClient.post("/chamber/inactivateImpersonation");
};
export const getSubscriptionReliefParams = () =>
  httpClient.get("/admin/subscriptionRelief");

export const searchSubscriptionWithoutRelief = (params: TsearchFilters) =>
  httpClient.get("/admin/searchSubscriptionWithoutRelief", { params: params });

export const insertSubscriptionRelief = ({
  year,
  subscriptionId,
  payDate,
}: {
  year: string;
  subscriptionId: string;
  payDate: string;
}) => {
  const formData = new FormData();
  if (year && year.length > 0) {
    formData.append("year", year);
  }
  if (subscriptionId && subscriptionId.toString().length > 0) {
    formData.append("subscriptionId", subscriptionId);
  }
  if (payDate && payDate.length > 0) {
    formData.append("payDate", payDate);
  }
  return httpClient.post("/admin/insertSubscriptionRelief", formData);
};

export const submitSql = (
  filters: TSubmitSqlFilters,
): AxiosPromise<TSubmitSqlResponse> => {
  const formData = new FormData();
  formData.append("sql", filters.sql);
  return httpClient.post("/admin/quickSql", formData);
};

export const getMaintenanceInfo = () =>
  httpClient.get("/admin/getMaintenanceFormInfo");

export const submitMaintenanceForm = (data: {
  maintenance: string | null;
  globalMessage: string | null;
}) => {
  const formData = new FormData();

  data.maintenance && formData.append("maintenance", data.maintenance);
  data.globalMessage && formData.append("globalMessage", data.globalMessage);

  return httpClient.post("/admin/changeMaintenanceInfo", formData);
};

export const getFixApplicationFormParams = (formData: FormData) =>
  httpClient.post("/admin/fixApplicationForm", formData);

export const updateSepaPayment = ({
  saleDate,
  amount,
  ri3,
}: {
  saleDate: string;
  amount: string;
  ri3: string;
}) => {
  const formData = new FormData();
  if (saleDate && saleDate.length > 0) {
    formData.append("saleDate", saleDate);
  }
  if (amount && amount.length > 0) {
    formData.append("amount", amount);
  }
  if (ri3 && ri3.length > 0) {
    formData.append("ri3", ri3);
  }
  return httpClient.post("/admin/updateSepa", formData);
};

export const getQuickConfigurationParams = () =>
  httpClient.get("/admin/getQuickConfigurationParams");

export const submitConfiguration = (data: {
  autoCloseNumber: number;
  updateApplicationsForSubscriptionsNumber: number;
}) => {
  const formData = new FormData();
  formData.append("autoCloseNumber", data.autoCloseNumber.toString());
  formData.append(
    "updateApplicationsForSubscriptionsNumber",
    data.updateApplicationsForSubscriptionsNumber.toString(),
  );
  formData.append("submit", "true");
  return httpClient.post("/admin/quickConfiguration", formData);
};

export const getPaymentsFix = (formData: FormData) =>
  httpClient.post("/admin/paymentsFix", formData);

export const paymentsExchangeFix = ({
  ri3,
  unPaidRi3,
}: {
  ri3: string;
  unPaidRi3: string;
}) => {
  const formData = new FormData();
  if (ri3 && ri3.length > 0) {
    formData.append("ri3", ri3);
  }
  if (unPaidRi3 && unPaidRi3.length > 0) {
    formData.append("unPaidRi3", unPaidRi3);
  }
  return httpClient.post("/admin/paymentsExchangeFix", formData);
};

export const getNewChamberFeature = () =>
  httpClient.get("/admin/getNewChamberFeature");

export const changeNewChamberFeature = (data: {
  newChamberFeature: string;
}) => {
  const formData = new FormData();

  data.newChamberFeature &&
    formData.append("newChamberFeature", data.newChamberFeature);

  return httpClient.post("admin/changeNewChamberFeature", formData);
};

export const sendNotificationToGeneral = ({
  titleGr,
  bodyGr,
  titleEn,
  bodyEn,
  url,
}: {
  titleGr: string;
  bodyGr: string;
  titleEn: string;
  bodyEn: string;
  url: string;
}) => {
  const formData = new FormData();
  if (titleGr && titleGr.length > 0) {
    formData.append("titleGr", titleGr);
  }
  if (bodyGr && bodyGr.length > 0) {
    formData.append("bodyGr", bodyGr);
  }
  if (titleEn && titleEn.length > 0) {
    formData.append("titleEn", titleEn);
  }
  if (bodyEn && bodyEn.length > 0) {
    formData.append("bodyEn", bodyEn);
  }
  formData.append("url", url === null ? "" : url);
  return httpClient.post("/admin/sendNotificationToGeneral", formData);
};

export const getSendNotificationToCompanyParams = () =>
  httpClient.get("/admin/sendNotificationToCompany");

export const getCompanies = (formData: FormData) =>
  httpClient.post("/admin/getCompaniesJSON", formData);

export const sendNotificationToCompaniesForm = ({
  m01_ids,
  corporateStatusInput,
  chamberDepartmentInput,
  taxServiceInput,
  prefectureInput,
  municipalityInput,
  titleGr,
  bodyGr,
  titleEn,
  bodyEn,
  url,
}: {
  m01_ids: string;
  corporateStatusInput: string;
  chamberDepartmentInput: string;
  taxServiceInput: string;
  prefectureInput: string;
  municipalityInput: string;
  titleGr: string;
  bodyGr: string;
  titleEn: string;
  bodyEn: string;
  url: string;
}) => {
  const formData = new FormData();
  formData.append("m01_ids", m01_ids);
  formData.append("corporateStatusInput", corporateStatusInput);
  formData.append("chamberDepartmentInput", chamberDepartmentInput);
  formData.append("taxServiceInput", taxServiceInput);
  formData.append("prefectureInput", prefectureInput);
  formData.append("municipalityInput", municipalityInput);
  formData.append("titleGr", titleGr);
  formData.append("bodyGr", bodyGr);
  formData.append("titleEn", titleEn);
  formData.append("bodyEn", bodyEn);
  formData.append("url", url === null ? "" : url);
  return httpClient.post("/admin/sendNotificationToCompaniesForm", formData);
};

export const getNotificationsToAllHistory = (formData: FormData) =>
  httpClient.post("/admin/getNotificationsToAllHistoryJSON", formData);

export const getNotificationsToCompanyHistory = (formData: FormData) =>
  httpClient.post("/admin/getNotificationsToCompanyHistoryJSON", formData);

export const getNotificationDetails = (
  formData: FormData,
  detailsType: string,
) => httpClient.post(`/admin/notification${detailsType}Details`, formData);

export const getBulkViolationsQueueParams = (
  start: number,
  length: number,
  hasError: boolean
) => {return httpClient.get("violationCase/getBulkViolationsQueue", {params: {start, length, hasError}
});
};

export const getViolationsTypesParams = () : Promise<AxiosResponse<ViolationType[]>> =>
  httpClient.get("complaint/getViolationTypes");

export const uploadBulkViolations = (formData: FormData) =>
  httpClient.post("violationCase/uploadBulkViolations", formData);

export const downloadKakIpReport = (kaks: string): AxiosPromise<Blob> => {
  const formData = new FormData();
  formData.append("kaks", kaks);
  return httpClient.post("/admin/kakIpReport", formData, {
    responseType: "blob",
  });
};

const paymentIntegrityFormData = (data: TPaymentIntegrityParams) => {
  const formData = new FormData();
  formData.append("type", data.type);
  formData.append("method", data.method);
  formData.append("identifierKind", data.identifierKind);
  formData.append("identifier", data.identifier);
  return formData;
};

export const checkPaymentIntegrity = (
  data: TPaymentIntegrityParams,
): AxiosPromise<TPaymentIntegrityReport> =>
  httpClient.post("/admin/paymentIntegrityCheck", paymentIntegrityFormData(data));

export const fixPaymentIntegrity = (
  data: TPaymentIntegrityParams,
): AxiosPromise<TPaymentIntegrityReport> =>
  httpClient.post("/admin/paymentIntegrityFix", paymentIntegrityFormData(data));

export const insertPaymentIntegrityEmails = (
  data: TPaymentIntegrityInsertEmailsParams,
): AxiosPromise<TPaymentIntegrityReport> => {
  const formData = paymentIntegrityFormData(data);
  data.emails.forEach((email) => formData.append("emails", email));
  return httpClient.post("/admin/paymentIntegrityInsertEmails", formData);
};
